<script setup lang="ts">
import { useRegistryUtils } from '@/composables/useRegistryUtils'
import { inject } from 'vue'
import { FireRiskDashboardViewModel } from '../../viewmodels/FireRiskDashboard.viewmodel'
import FarmFireRiskChartCard from '../FarmFireRiskChartCard.vue'
import Pagination from '@/components/ui/pagination/Pagination.vue'

const vm = inject<FireRiskDashboardViewModel>('fire-risk-dashboard-viewmodel')!

const { pageData, page, pageSize, onPageChange } = useRegistryUtils(vm.recentFireRisks, [])

pageSize.value = 3
</script>

<template>
	<div class="flex flex-col p-8">
		<span class="text-default-bold !text-blue-base !text-center mb-6"
			>Risco de incêndio por Fazenda</span
		>
		<div class="flex mb-6">
			<farm-fire-risk-chart-card
				v-for="farm in pageData"
				:key="farm.id"
				:farm="farm"
			/>
		</div>
		<pagination
			v-if="pageData?.length"
			:key="vm.recentFireRisks.value?.length"
			:total="vm.recentFireRisks.value?.length"
			:page="page"
			:page-size="pageSize"
			hide-line-count
			@paginationSettings="onPageChange"
		/>
	</div>
</template>
